import { render, staticRenderFns } from "./ChangeInvoice.vue?vue&type=template&id=6504fab9&scoped=true&"
import script from "./ChangeInvoice.vue?vue&type=script&lang=js&"
export * from "./ChangeInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ChangeInvoice.vue?vue&type=style&index=0&id=6504fab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504fab9",
  null
  
)

export default component.exports